import { Box } from '@mui/material';

import { Skeleton } from '@/components';

import { EpisodeCardLargeDimensions } from '../../constants';

export const EpisodeCardLargeSkeleton = () => (
  <Box
    sx={{
      width: EpisodeCardLargeDimensions.width,
      height: EpisodeCardLargeDimensions.height,
    }}>
    <Skeleton
      variant="rounded"
      width="auto"
      sx={{
        height: EpisodeCardLargeDimensions.height,
        borderRadius: 4,
      }}
    />
  </Box>
);
